module.exports = __webpack_public_path__ + "static/media/lata-acrilica.c5a9c33f.webp";